import { SlideHeader } from "../../../SlideHeader";

interface Citation {
  label: string;
  url: string;
}

interface Source {
  num: number;
  title: string;
  description: string;
  refs: Citation[];
}

const SOURCES: Source[] = [
  {
    num: 1,
    title: "App Store / Google Play app counts",
    description: "The universe of apps competing for installs (publishers, live apps, new-app cadence).",
    refs: [
      {
        label: "42Matters — App Store stats",
        url: "https://42matters.com/stats",
      },
      {
        label: "Buildfire — App statistics",
        url: "https://buildfire.com/app-statistics/",
      },
      {
        label: "42Matters — Google Play statistics & trends",
        url: "https://42matters.com/google-play-statistics-and-trends",
      },
    ],
  },
  {
    num: 2,
    title: "AI-coding-driven App Store submission surge",
    description: "Q1 2026: +84% YoY new App Store submissions; 2025 full year ~600K (+30% YoY).",
    refs: [
      {
        label: "9to5Mac — App Store sees 84% surge in new apps (April 2026)",
        url: "https://9to5mac.com/2026/04/06/app-store-sees-84-surge-in-new-apps-as-ai-coding-tools-take-off/",
      },
    ],
  },
  {
    num: 3,
    title: "Apple LLM-augmented App Store search ranking",
    description: "Apple fine-tuned a 3B-parameter LLM to re-rank App Store search; semantic relevance now a first-class ranking signal.",
    refs: [
      {
        label: "Apple ML Research — Augmenting App Search with LLMs",
        url: "https://machinelearning.apple.com/research/augmenting-app",
      },
      {
        label: "9to5Mac — Apple ran a test on the App Store (March 2026)",
        url: "https://9to5mac.com/2026/03/06/apple-ran-a-test-on-the-app-store-to-see-if-ai-could-improve-search-result-rankings/",
      },
    ],
  },
  {
    num: 4,
    title: "LLM surfaces as the new app-discovery layer",
    description: "ChatGPT captured 84.2% of all AI-driven referrals; AI sessions grew 4.29× YoY.",
    refs: [
      {
        label: "Previsible — 2025 State of AI Discovery Report",
        url: "https://previsible.io/seo-strategy/ai-seo-study-2025/",
      },
      {
        label: "Fairing — LLM Product Discovery Benchmarks Q2 2025",
        url: "https://fairing.co/resources/benchmarks/llm-product-discovery-benchmarks-q2-2025",
      },
    ],
  },
  {
    num: 5,
    title: "EU DMA forces iOS open to alternative app stores",
    description: "Apple opened iOS to third-party stores and alt payments in EU in 2025; EC preliminary findings issued April 2025.",
    refs: [
      {
        label: "European Commission — DMA preliminary findings, April 2025",
        url: "https://digital-markets-act.ec.europa.eu/commission-closes-investigation-apples-user-choice-obligations-and-issues-preliminary-findings-rules-2025-04-23_en",
      },
      {
        label: "TechCrunch — Alternative app stores coming to the EU (March 2025)",
        url: "https://techcrunch.com/2025/03/13/move-over-apple-meet-the-alternative-app-stores-coming-to-the-eu",
      },
    ],
  },
  {
    num: 6,
    title: "Global mobile economy size and growth distribution",
    description: "2025 global IAP revenue $167B (+10.6% YoY); 149B downloads; most growth outside any single home market.",
    refs: [
      {
        label: "Sensor Tower — State of Mobile 2026",
        url: "https://sensortower.com/report/state-of-mobile-2026",
      },
      {
        label: "9to5Mac — Sensor Tower's State of Mobile 2026 (Jan 2026)",
        url: "https://9to5mac.com/2026/01/21/sensor-towers-state-of-mobile-2026-tiktok-dominates-ai-apps-surge-games-lose-ground/",
      },
    ],
  },
  {
    num: 7,
    title: "Google Play AI-powered discovery (Ask Play + Gemini)",
    description: "Gemini-powered conversational search inside Play Store; Google states it already answers 95% of user queries.",
    refs: [
      {
        label: "Android Developers Blog — I/O 2026: What's new in Google Play",
        url: "https://android-developers.googleblog.com/2026/05/io-2026-whats-new-in-google-play.html",
      },
      {
        label: "9to5Google — Ask Play chatbot launch (May 2026)",
        url: "https://9to5google.com/2026/05/19/google-play-store-gets-new-ask-play-chatbot-as-gemini-starts-recommending-apps/",
      },
    ],
  },
  {
    num: 8,
    title: "ASD Reports — ASO Software Market 2025–2035",
    description: "TAM: $0.53B (2024) → $3.28B (2035) at 18.0% CAGR.",
    refs: [
      {
        label: "ASD Reports — Global ASO Software Market Size Study",
        url: "https://www.asdreports.com/market-research-report-680194/global-app-store-optimization-software-market-size-study-regional-forecasts",
      },
    ],
  },
  {
    num: 9,
    title: "Global Growth Insights — ASO Software Market 2035",
    description: "TAM: $0.58B (2025) → $1.89B (2035) at 12.5% CAGR.",
    refs: [
      {
        label: "Global Growth Insights — ASO Software Market Size 2035",
        url: "https://www.globalgrowthinsights.com/market-reports/app-store-optimization-aso-software-market-110608",
      },
    ],
  },
  {
    num: 10,
    title: "Precision Reports — ASO Tools Market",
    description: "TAM: $0.72B (2026) → $3.68B (2035) at 19.9% CAGR.",
    refs: [
      {
        label: "Precision Reports — ASO Tools Market Size, Share, Forecast",
        url: "https://www.precisionreports.co/market-reports/app-store-optimization-aso-tools-market-601944",
      },
    ],
  },
  {
    num: 11,
    title: "Spherical Insights — ASO Tools Software Market",
    description: "TAM: $0.95B (2024) → $7.56B (2035) at 20.7% CAGR.",
    refs: [
      {
        label: "Spherical Insights — Top 20 Companies in Global ASO Tools",
        url: "https://www.sphericalinsights.com/blogs/top-20-companies-in-global-app-store-optimization-tools-software-market-global-share-market-size-revenue-report-2024-2035",
      },
    ],
  },
  {
    num: 12,
    title: "What we count as ASO tooling",
    description:
      "App intelligence, review analytics, localization, workflow automation, store KPI analytics, competitor monitoring, AI / LLM discoverability monitoring, and integrated App Store / Google Play publishing — not just keyword / ranking tools.",
    refs: [],
  },
  {
    num: 13,
    title: "M&A + VC across ASO and adjacent app-intelligence (since 2020)",
    description:
      "Aggregate of disclosed deal values in the ASO and adjacent app-intelligence / app-growth space since 2020, illustrating sustained acquirer and investor appetite in the category. Notable deals: AppLovin acquired Adjust (announced Feb 2021 at ~$1B; closed Apr 2021); Sensor Tower acquired data.ai (Mar 2024, terms undisclosed); AppTweak Series B ($22M, Apr 2021); AppFollow Series A ($5M, Oct 2020). Combined disclosed deal value ≈ $1B+.",
    refs: [
      {
        label: "Business Wire — AppLovin to Acquire Adjust (Feb 2021, ~$1B)",
        url: "https://www.businesswire.com/news/home/20210203005880/en/CORRECTING-and-REPLACING-AppLovin-to-Acquire-Mobile-App-Measurement-Market-Leader-Adjust-to-Expand-its-Global-Technology-Platform",
      },
      {
        label: "TechCrunch — Sensor Tower acquires rival data.ai (Mar 2024)",
        url: "https://techcrunch.com/2024/03/18/app-analytics-firm-sensor-tower-acquires-rival-data-ai/",
      },
      {
        label: "AppTweak — $22M Series B (Apr 2021)",
        url: "https://www.apptweak.com/en/aso-blog/apptweak-raises-22-million-to-grow-aso-platform-worldwide",
      },
      {
        label: "TechCrunch — AppFollow raises $5M Series A (Oct 2020)",
        url: "https://techcrunch.com/2020/10/28/app-management-startup-appfollow-raises-5m-series-a-round-led-by-nauta-capital/",
      },
    ],
  },
  {
    num: 14,
    title: "ASO professionals & agencies population sizing",
    description:
      "Estimated 5K+ ASO specialists and agencies worldwide. Composition: ~400 dedicated ASO agencies (Phiture, Gummicube, Yodel Mobile, AppAgent, App Radar Agency, MobileAction Agency, etc.); ~3K independent ASO consultants visible via LinkedIn ASO-titled roles; ~2K in-house ASO specialists embedded at publisher organizations. Directional estimates — no central registry of ASO professionals exists. Named-agency anchors are individually verifiable via the agencies' own sites.",
    refs: [
      {
        label: "Phiture — ASO and growth agency",
        url: "https://phiture.com/",
      },
      {
        label: "Gummicube — ASO platform and agency",
        url: "https://www.gummicube.com/",
      },
      {
        label: "Yodel Mobile — mobile app growth agency",
        url: "https://yodelmobile.com/",
      },
      {
        label: "AppAgent — mobile growth and ASO agency",
        url: "https://www.appagent.com/",
      },
    ],
  },
  {
    num: 15,
    title: "Mobile app marketing spend — $109B in 2025",
    description:
      "AppsFlyer's annual industry report measures total global mobile app marketing spend at $109B in 2025: $78B paid user acquisition + $31B remarketing. This is media spend, not addressable tooling TAM — Apptonomy sells software riding on top of this spend, not the spend itself. The $109B figure contextualizes the sector Apptonomy plays in.",
    refs: [
      {
        label: "AppsFlyer — Top Data Trends of 2025 report (Dec 2025)",
        url: "https://www.appsflyer.com/resources/reports/top-5-data-trends-report/",
      },
    ],
  },
  {
    num: 16,
    title: "Addressable tooling TAM (adjacent to ASO) — directional estimate",
    description:
      "Directional sum across recognized adjacent tooling categories: ASO software ($0.5–1.0B today, see entries 8–11); MMP/attribution platforms (~$1–3B, with AppsFlyer alone reportedly $200–400M revenue); UA tooling layer distinct from media spend (~$2–5B); mobile analytics (~$0.5–1.0B); creative/content generation for ads (~$0.5B and growing). Combined range ~$5–15B. Not citable to a single source — for directional pitch use only.",
    refs: [],
  },
  {
    num: 17,
    title: "SaaS unit-economics benchmarks (retention, LTV:CAC, payback)",
    description:
      "Industry benchmark aggregations used to sanity-check the Economics slide's steady-state assumptions. SMB-focused SaaS monthly churn norms of 3–5% imply a ~20–33-month average customer lifetime (the deck assumes 24 months — mid-range). 3:1 LTV:CAC is the generally accepted investor threshold (the deck targets ≥5:1). CAC payback of ≤12 months is considered healthy for SMB SaaS (the deck targets ≤8 months). The tier-mix assumption (45/40/10/5) has no credible public benchmark and remains a founder-projected estimate.",
    refs: [
      {
        label: "Churnkey — What's a normal churn rate in SaaS?",
        url: "https://churnkey.co/blog/whats-a-normal-churn-rate-in-saas/",
      },
      {
        label: "Fiscallion — SaaS unit economics: CAC, LTV, payback, Rule of 40",
        url: "https://www.fiscallion.io/blog/saas-unit-economics",
      },
    ],
  },
];

export default function Sources() {
  return (
    <div className="flex w-full flex-col px-6 pt-8 pb-4 text-slate-900 md:h-full md:px-24 md:pt-16 md:pb-8">
      <SlideHeader unnumbered eyebrow="Appendix E · Sources &amp; Footnotes" />
      <div className="grid grid-cols-1 gap-x-8 gap-y-4 md:flex-1 md:grid-cols-2 md:gap-x-10 md:gap-y-5">
        {SOURCES.map((s) => (
          <SourceEntry key={s.num} {...s} />
        ))}
      </div>
    </div>
  );
}

function SourceEntry({ num, title, description, refs }: Source) {
  return (
    <div className="flex gap-3">
      <span className="shrink-0 text-base font-bold tabular-nums text-blue-700 md:text-lg">
        {num}.
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold leading-snug text-slate-900 md:text-base">
          {title}
        </p>
        <p className="mt-0.5 text-xs leading-snug text-slate-600 md:text-[13px]">
          {description}
        </p>
        {refs.length > 0 ? (
          <ul className="mt-1 space-y-0.5">
            {refs.map((r) => (
              <li
                key={r.url}
                className="text-[11px] leading-snug text-slate-500 md:text-xs"
              >
                <a
                  href={r.url}
                  target="_blank"
                  rel="noreferrer"
                  className="underline decoration-slate-300 underline-offset-2 hover:text-blue-700 hover:decoration-blue-700"
                >
                  {r.label}
                </a>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </div>
  );
}
